export * from "wretch/addons";
import snakeCaseKeys from "snakecase-keys";
import camelcaseKeys from "camelcase-keys";
import { g as getResolverForContentType } from "./get-resolver-for-content-type-DlHTDn7n.js";
const caller = {
  wretch: {
    caller(callerName) {
      return this.headers({
        "X-Caller": callerName
      });
    }
  }
};
const snakeCaseBody = (defaultOptions) => {
  return {
    wretch: {
      snakeCaseBody(payload, options) {
        const snakeCasedPayload = snakeCaseKeys(payload, {
          ...defaultOptions,
          ...options
        });
        return this.body(JSON.stringify(snakeCasedPayload)).content(
          "application/json"
        );
      }
    }
  };
};
const validAddonDefaultOptions = {
  preprocess: (val) => {
    return camelcaseKeys(val, {
      deep: true,
      preserveConsecutiveUppercase: true
    });
  }
};
const valid = (defaultOptions = validAddonDefaultOptions) => {
  return {
    resolver: {
      async valid(schema, options) {
        const finalOptions = {
          ...defaultOptions,
          ...options
        };
        const preprocess = finalOptions.preprocess || ((val) => val);
        const getResolver = async () => {
          const response = await this._fetchReq;
          const contentType = response.headers.get("content-type");
          return getResolverForContentType(contentType);
        };
        this._wretchReq._options.valid = {
          preprocess,
          schema
        };
        const resolver = await getResolver();
        return this[resolver](
          (data) => schema.parse(preprocess(data))
        );
      }
    }
  };
};
export {
  caller,
  snakeCaseBody,
  valid,
  validAddonDefaultOptions
};
//# sourceMappingURL=addons.js.map
